<script setup lang="ts">
import '@/utils/floorUtils.ts';

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { SelectOption } from '@/classes/SelectOption';
import RadioGroup from '@/components/filters/RadioGroup.vue';
import { useFloor } from '@/composables/useFloor';
import type { LocaleSchema } from '@/locales/index';

const modelValue = defineModel<number>();

const props = defineProps<{
  options: number[]
}>();

const { getFloorTextByNumber } = useFloor();

const { t } = useI18n<{ message: LocaleSchema }>({
  useScope: 'global',
});

const value = computed({
  get: () => modelValue.value?.toString(),
  set: (value: string) => {
    modelValue.value = parseInt(value, 10);
  },
});

const floorOptions = computed(() => {
  return props.options.map((option: number) => new SelectOption(option.toString(), getFloorTextByNumber(option)));
});
</script>

<template>
  <fieldset>
    <legend>{{ t('forms.units.filters.floor.title') }}</legend>
    <RadioGroup v-model="value"
                :options="floorOptions"
                class="tagRadios_floorFilter" />
  </fieldset>
</template>
